import { render, staticRenderFns } from "./ColorInfo.vue?vue&type=template&id=28e30ad7&"
import script from "./ColorInfo.vue?vue&type=script&lang=js&"
export * from "./ColorInfo.vue?vue&type=script&lang=js&"
import style0 from "./ColorInfo.vue?vue&type=style&index=0&id=28e30ad7&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports